export const SET_LOGOUT = "SET_LOGOUT";
export const SET_LOGIN = "SET_LOGIN";
export const SET_TOKEN = "SET_TOKEN";
export const SET_ENTITAS = "SET_ENTITAS";